import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment';
import { PMREMGenerator } from 'three';
import type { WebGLRenderer } from 'three';

export const createRoomEnv = (renderer: WebGLRenderer) => {
    const environment = new RoomEnvironment(renderer);
    const pmremGenerator = new PMREMGenerator(renderer);
    const target = pmremGenerator.fromScene(environment);
    return target.texture;
};
